import { create } from "zustand";
import { getTraceId } from "../../utils";
import type { MessageStore } from "../types";


export const useMessageStore = create<MessageStore>((set) => ({
    messages: [],
    addMessage: (message) => {
        const traceId = getTraceId();
        set((state) => ({
            messages: [...state.messages, { ...message, traceId }]
        }));
    },
    addError: (error) => {
        useMessageStore.getState().addMessage({
            type: "error",
            timestamp: new Date().toISOString(),
            message: error
        });
    },
    addInfo: (info) => {
        useMessageStore.getState().addMessage({
            type: "info",
            timestamp: new Date().toISOString(),
            message: info
        });
    },
    addSuccess: (success) => {
        useMessageStore.getState().addMessage({
            type: "success",
            timestamp: new Date().toISOString(),
            message: success
        });
    },
    removeMessage: (index: number) => set((state: MessageStore) => ({ messages: state.messages.filter((_, i) => i !== index) })),
    clearMessages: () => set({ messages: [] })
}));
